import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import organizationallevelApi from 'api/organizationallevelApi'

export const thunkOrganizationallevel = createAsyncThunk(
  'organizationallevel/getAll',
  async (param, thunkApi) => {
    try {
      const res = await organizationallevelApi.getAll(param)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
const reportSlice = createSlice({
  name: 'organizationallevel',
  initialState: {
    processes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(thunkOrganizationallevel.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(thunkOrganizationallevel.fulfilled, (state, action) => {
        state.loading = false
        state.processes = action.payload // Cập nhật state với dữ liệu trả về
      })
  },
})

const { reducer } = reportSlice
export default reducer
